import React from 'react';
import { CheckIcon } from 'lucide-react';
export function Hero() {
  const features = ['Acceso inmediato', 'Formato digital', 'Compatible celular y PC', 'Garantía de 7 días'];
  return <section className="bg-white pt-6 pb-10 md:pt-10 md:pb-14" data-id="element-60">
      <div className="max-w-3xl mx-auto px-5 w-full text-center" data-id="element-61">
        <div className="inline-block bg-olive/10 text-olive px-3 py-1.5 rounded-full text-xs md:text-sm font-medium mb-5" data-id="element-62">
          +12.000 dueños mejoraron la alimentación de sus mascotas
        </div>

        <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-ink mb-4 leading-[1.1]" data-id="element-63">
          +450 Recetas Saludables para mascotas
        </h1>
        <p className="font-serif text-lg md:text-xl text-forest mb-4" data-id="element-64">
          Alimenta a tu mascota como si fuera parte de tu familia
        </p>

        <p className="text-base md:text-lg text-gray-600 mb-6 leading-relaxed max-w-2xl mx-auto" data-id="element-65">
          Más de 450 recetas naturales, planes nutricionales y guías
          especializadas para que viva más sana, más fuerte y más feliz.
        </p>

        <div className="mb-6" data-id="element-66">
          <img src="https://cdn.magicpatterns.com/uploads/tgqXEJ3zY4r6A9c1kBdvf2/709844502_996776769497665_8383829642374930107_n.jpg" alt="+450 Recetas Saludables para mascotas" className="w-full max-w-sm md:max-w-md mx-auto rounded-2xl shadow-2xl" data-id="element-67" />
        </div>

        <div className="flex items-baseline justify-center gap-2.5 mb-5" data-id="element-68">
          <span className="text-gray-400 line-through text-base" data-id="element-69">$50.000</span>
          <span className="text-3xl md:text-4xl font-bold text-forest" data-id="element-70">
            $19.990
          </span>
        </div>

        <a href="https://impulsodigital.vip/cart/44794622902358:1" className="inline-block w-full max-w-sm text-center bg-forest text-white px-8 py-4 rounded-lg text-base md:text-lg font-semibold hover:bg-forest/90 transition-colors shadow-lg" data-id="element-71">
          QUIERO ACCESO
        </a>

        <div className="grid grid-cols-2 gap-x-4 gap-y-2 max-w-md mx-auto mt-6 text-sm" data-id="element-72">
          {features.map((feature, index) => <div key={index} className="flex items-center gap-2 justify-start" data-id="element-73">
              <CheckIcon className="w-4 h-4 text-forest flex-shrink-0" data-id="element-74" />
              <span className="text-gray-700" data-id="element-75">{feature}</span>
            </div>)}
        </div>
      </div>
    </section>;
}